// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgQuookerIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M9.951 1.023c3.07 0 5.12 1.306 6.363 3.033 1.199 1.664 1.588 3.627 1.588 4.96V11h.898a1.2 1.2 0 0 1 1.2 1.2V17h1v-2.723a.745.745 0 0 1 1.488 0V17h.112c.22 0 .4.18.4.4v1.2a.4.4 0 0 1-.4.4H20v2a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-8.8a1.2 1.2 0 0 1 1.2-1.2h1.197V9.015c0-.9-.28-2.284-1.091-3.41-.766-1.062-2.066-1.99-4.355-1.99-2.288 0-3.588.928-4.353 1.99-.811 1.126-1.092 2.51-1.092 3.41L4.5 11H1.994L2 9.015c0-1.332.39-3.295 1.588-4.959C4.832 2.33 6.88 1.023 9.95 1.023ZM15 21h3v-8h-3z" />
  </g>
);
export default SvgQuookerIcon;
SvgQuookerIcon.displayName = 'SvgQuookerIcon';
